import { Sorting } from "@clayui/core/lib/table/context";
import {
  DEFAULT_ORDER_BY_INGESTION_ACCOUNTS,
  DEFAULT_SORT_BY_INGESTION_ACCOUNTS
} from "../../../../utils/constants/reducerConstants";
import { ITableHeader } from "interfaces/filterIngestion.interface";
import styles from "./IngestionAccounts.module.scss";

export const tableHeaderNoCheckbox: ITableHeader[] = [
  {
    id: "name",
    name: "Account",
    sortable: true
  },
  {
    id: "no_of_domains",
    name: "No. of Domains",
    sortable: true,
    customClass: styles.noWrap
  },
  {
    id: "no_of_emails",
    name: "No. of Email Ids",
    sortable: true,
    customClass: styles.noWrap
  },
  {
    id: "total_active_members",
    name: "Members",
    sortable: true
  },
  {
    id: "classification",
    name: "Classification",
    sortable: true
  },
  {
    id: "updated_at",
    name: "Updated Date",
    sortable: true,
    customClass: styles.noWrap
  },
  {
    id: "comments",
    name: "Comments",
    sortable: false
  },
  {
    id: "is_active",
    name: "Status",
    sortable: true
  },
  {
    id: "action",
    name: "Actions",
    sortable: false
  }
];

export const tableHeader: ITableHeader[] = [
  {
    id: "checkbox"
  },
  {
    id: "name",
    name: "Account",
    sortable: true
  },
  {
    id: "no_of_domains",
    name: "No. of Domains",
    sortable: true,
    customClass: styles.noWrap
  },
  {
    id: "no_of_emails",
    name: "No. of Email Ids",
    sortable: true,
    customClass: styles.noWrap
  },
  {
    id: "total_active_members",
    name: "Members",
    sortable: true
  },
  {
    id: "classification",
    name: "Classification",
    sortable: true
  },
  {
    id: "updated_at",
    name: "Updated Date",
    sortable: true,
    customClass: styles.noWrap
  },
  {
    id: "comments",
    name: "Comments",
    sortable: false
  },
  {
    id: "is_active",
    name: "Status",
    sortable: true
  },
  {
    id: "action",
    name: "Actions",
    sortable: false
  }
];

export const predefinedValues = {
  pageSize: 200
};

export const defaultSort: Sorting = {
  column: DEFAULT_SORT_BY_INGESTION_ACCOUNTS,
  direction: DEFAULT_ORDER_BY_INGESTION_ACCOUNTS
};
